import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { myContainerStyle } from '../../../configs/ui/constant';
import MaterialTable from 'material-table';
import {
   headerStyle,
   tableIcons,
   tableStyle,
} from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';
import { StatusLabel, TypeLabel } from '../../../components/Status/StatusLabel';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import Create from '../../../components/Modal/RaasManagement/Create';
import Edit from '../../../components/Modal/RaasManagement/Edit';
import Delete from '../../../components/Modal/RaasManagement/Delete';
import MapCategoryRaas from '../../../components/Modal/RaasManagement/MapCategoryRaas';
import {
   faFileEdit,
   faSitemap,
   faTrashAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

const ImgItems = styled('img')`
   max-height: 80px;
   max-width: 150px;
   border-radius: 5px;
   box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
      0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
      0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
      0 100px 80px rgba(0, 0, 0, 0.12);
`;
const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      display: 'flex',
      border: `1px solid ${theme.palette.divider}`,
      flexWrap: 'wrap',
   },
}));

function RaasManagement(props) {
   const history = useHistory();
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [resp, setResp] = useState([]);
   const [data, setData] = useState([]);
   const [myModal, setMyModal] = useState('');
   const [showModal, setShowModal] = useState(false);
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.get('/GSB/dashboard/reward/GetList')
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            if (e.response) {
               const response = e.response.data;
               const statusCode = e.response.status;
               if (statusCode === 401) {
                  sessionStorage.clear();
                  localStorage.clear();
                  history.push('/');
               }
               enqueueSnackbar(response.errorAppMessageTh, {
                  variant: 'error',
               });
            } else console.error('site error');
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setTableData();
   }, [resp]);
   const setTableData = () => {
      if (resp.length > 0) {
         const dataForMap = resp;
         const formatted = dataForMap.map((value) => {
            return Object.assign(
               {},
               {
                  ...value,
                  data: value,
               },
            );
         });
         setIsLoading(false);
         setData(formatted);
      }
   };

   const refreshData = () => {
      setShowModal(false);
      setData([]);
      setMyModal('');
      getData();
   };

   const setModalStyle = (type, value) => {
      if (type === 'create') {
         setMyModal(
            <Create
               onClickClose={() => setShowModal(false)}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'mapping') {
         setMyModal(
            <MapCategoryRaas
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'edit') {
         setMyModal(
            <Edit
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      if (type === 'delete') {
         setMyModal(
            <Delete
               onClickClose={() => setShowModal(false)}
               data={value}
               onSuccess={() => refreshData()}
            />,
         );
      }
      setShowModal(!showModal);
   };

   return (
      <Paper style={myContainerStyle.root}>
         <Modal className={classes.modal} open={showModal}>
            <React.Fragment>{myModal}</React.Fragment>
         </Modal>
         <Box display='flex' my={1} alignItems='center'>
            <Box mx={1}>
               <Typography variant='h5'>จัดการของรางวัล</Typography>
            </Box>
            <Box mx={1}>
               <Button
                  variant='contained'
                  color='primary'
                  size='small'
                  startIcon={<FontAwesomeIcon icon={faPlus} size={'xs'} />}
                  onClick={() => {
                     setModalStyle('create', '');
                  }}
               >
                  เพิ่มของรางวัล
               </Button>
            </Box>
         </Box>
         <MaterialTable
            isLoading={isLoading}
            columns={[
               {
                  field: 'status',
                  title: 'สถานะ',
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  sorting: false,
                  export: false,
                  render: (rowData) => (
                     <StatusLabel
                        StatusType={rowData.status}
                        msg={rowData.statusDesc}
                     />
                  ),
               },
               {
                  field: 'type',
                  title: 'ประเภท',
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  sorting: false,
                  export: false,
                  render: (rowData) => <TypeLabel StatusType={rowData.type} />,
               },
               {
                  field: 'image',
                  title: 'รูปภาพ',
                  headerStyle: {
                     textAlign: 'center',
                  },
                  cellStyle: {
                     textAlign: 'center',
                  },
                  sorting: false,
                  export: false,
                  render: (rowData) =>
                     rowData.image && (
                        <ImgItems
                           src={rowData?.image?.highResUrl ?? ''}
                           alt={rowData?.image?.imageId ?? ''}
                        />
                     ),
               },
               {
                  field: 'rewardRef',
                  title: 'รหัสอ้างอิงของรางวัล',
               },
               {
                  field: 'rewardTh',
                  title: 'ชื่อภาษาไทย',
               },
               {
                  field: 'rewardEn',
                  title: 'ชื่อภาษาอังกฤษ',
               },
               {
                  field: 'formattedPoint',
                  title: 'มูลค่าการใช้คะแนน',
                  type: 'numeric',
               },
               {
                  field: 'validFrom',
                  title: 'ใช้ได้ตั้งแต่',
                  type: 'datetime',
                  render: (rowData) =>
                     dayjs(new Date(rowData.validFrom)).format(
                        'DD/MM/BBBB  HH:mm',
                     ),
               },
               {
                  field: 'validThrough',
                  title: 'ใช้ได้จนถึง',
                  type: 'datetime',
                  render: (rowData) =>
                     dayjs(new Date(rowData.validThrough)).format(
                        'DD/MM/BBBB  HH:mm',
                     ),
               },
            ]}
            data={data}
            options={{
               showTitle: false,
               headerStyle: headerStyle,
               actionsColumnIndex: -1,
               padding: 'dense',
               addRowPosition: 'first',
               actionsCellStyle: {
                  color: '#ccc',
               },
               pageSize: 5,
               pageSizeOptions: [5, 10, 25, 50, 100],
            }}
            localization={{
               body: {
                  editRow: { deleteText: 'ต้องการลบข้อมูลนี้ใช่หรือไม่?' },
               },
               header: { actions: 'ตัวจัดการ' },
            }}
            style={tableStyle}
            icons={tableIcons}
            actions={[
               {
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        icon={faRedoAlt}
                        size={'xs'}
                     />
                  )),
                  tooltip: 'Refresh Data',
                  isFreeAction: true,
                  onClick: () => refreshData(),
               },
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon ref={ref} {...props} icon={faSitemap} />
                  )),
                  onClick: (event, rowData) => {
                     setModalStyle('mapping', rowData.data);
                  },
                  tooltip: 'Mapping',
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={'#00a2e8'}
                        icon={faFileEdit}
                     />
                  )),
                  onClick: (event, rowData) => {
                     setModalStyle('edit', rowData.data);
                  },
                  tooltip: 'แก้ไข',
               }),
               (rowData) => ({
                  icon: React.forwardRef((props, ref) => (
                     <FontAwesomeIcon
                        ref={ref}
                        {...props}
                        color={'#ed1c24'}
                        icon={faTrashAlt}
                     />
                  )),
                  onClick: (event, rowData) => {
                     setModalStyle('delete', rowData.data);
                  },
                  tooltip: 'ลบ',
               }),
            ]}
         />
      </Paper>
   );
}

export default RaasManagement;
